import type { ReactNode } from "react";
import { BrandMark } from "@/components/layout/brand-mark";
import { ThemeToggle } from "@/components/layout/theme-toggle";
import { SocialPanel } from "@/features/auth/components/social-panel";

interface AuthScreenLayoutProps {
	children: ReactNode;
}

export function AuthScreenLayout({ children }: AuthScreenLayoutProps) {
	return (
		<div className="auth-screen">
			<div className="auth-screen__main">
				<div className="auth-screen__header">
					<BrandMark />
					<ThemeToggle />
				</div>
				<div className="auth-screen__content">
					<div className="auth-screen__panel">{children}</div>
				</div>
			</div>
			<SocialPanel />
		</div>
	);
}
